import { WhatsappBusinessVerificationStatus } from "@jugl-web/rest-api";

export const shouldShowBusinessVerificationAlert = (
  status: WhatsappBusinessVerificationStatus
): boolean => {
  const alertStatuses: WhatsappBusinessVerificationStatus[] = [
    "pending_need_more_info",
    "pending_submission",
    "failed",
    "ineligible",
    "rejected",
    "revoked",
    "expired",
  ];

  return alertStatuses.includes(status);
};
